module.exports = __webpack_public_path__ + "static/img/far2.9398cb92.png";